import React from 'react';
import AdminMasterCalc from './AdminMasterCalc.js';

const SalesMasterCalc = ({ db }) => <AdminMasterCalc db={db} mode="sales" />;

export default SalesMasterCalc;
